<template>
  <div class="PreservationProgress">
      <el-dialog width="425px" :visible.sync="popuStatus" :before-close="closePopu">
          <img src="~common/images/examination/icon-bi.png" alt="bi">
          <p>确认下次再做将为你保存当前答题进度</p>
          <div class="btnlist">
              <el-button type="info" @click="closePopu">继续做题</el-button>
              <el-button type="primary" @click="next">下次继续</el-button>
          </div>
      </el-dialog>
  </div>
  <!-- end 保存进度弹窗 -->
</template>

<script>
export default {
  name: 'PreservationProgress',
  data () {
    return {
        popuStatus: false
    }
  },
  mounted () {},
  methods: {
      startPopu() { // 开启弹窗
          this.popuStatus = true
      },
      closePopu() { // 关闭弹窗
        this.popuStatus = false
      },
      next() {  // 下次继续做题 保存本次进度
        // 获取已做题目答案
        let answerList = this.$parent._combinationExaminationAontent()
        // 回调考试提交接口
        this.$parent.CallbackSaveExamRecord(answerList, () => {
            // 前往个人中心
            this.$message.success('保存进度成功')
            setTimeout(() => {
                this.$router.push({name: 'StartTopic'})
            }, 500)
        })
      }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.PreservationProgress {
    .el-dialog__body {
        padding-top: 18px;
    }
    img {
        margin: auto;
        width: 49px;
        height: 55px;
    }
    p {
        margin-top: 22px;
        font-size: 16px;
        text-align: center;
    }
    .btnlist {
        margin-top: 25px;
        text-align: center;

        .el-button {
            min-height: 30px;
            height: 30px;
            padding: 5px 32px;
            span {
                font-size: 14px;
            }
            & ~ .el-button {
                margin-left: 30px;
            }
        }
    }

}
</style>